export default __webpack_public_path__ + "static/media/placeholder_dummy2016-musikschule01-mobile-de.933b4833.png";